$(document).ready(function () {
  applyRequiredVariant();
  setUnavailable();
  selectedItemSetUnavailable();
});

function applyRequiredVariant() {
  try {
    if ( typeof allVariants !== 'undefined' && allVariants && !isSelectedVariant_available ) {
      const currentVariant = findObjectByKey(allVariants, 'is_default', true);
      console.log ( 'currentVariant', currentVariant );
      if ( typeof currentVariant !== 'undefined' && currentVariant ) {
        setTimeout(() => {
          $( `.option-selector[op-position="1"] .newCustomSelect__btn > span` ).html( `${ currentVariant.opt_1.replace( '^', '"' ) }` );
          $( `.option-selector[op-position="1"] .newCustomSelect__list .newCustomSelect__item` )
            .removeAttr( `selected` );
          setTimeout(() => {
            $( `.option-selector[op-position="1"] .newCustomSelect__list .newCustomSelect__item[data-value="${ currentVariant.opt_1 }"]` )
            .attr( `selected`,"" );
          }, 50);

          if ( typeof currentVariant.opt_2 !== 'undefined' && currentVariant.opt_2 ) {
            console.log ( '2nd option available',  );
            $( `.option-selector[op-position="2"] .newCustomSelect__btn > span` ).html( `${ currentVariant.opt_2.replace( '^', '"' ) }` );
            $( `.option-selector[op-position="2"] .newCustomSelect__list .newCustomSelect__item` ).removeAttr( `selected` );
            setTimeout(() => {
              console.log ( 'now changing ', currentVariant.opt_2 );
              $( `.option-selector[op-position="2"] .newCustomSelect__list .newCustomSelect__item[data-value="${ currentVariant.opt_2 }"]` )
              .attr( `selected`, true );
            }, 55);
          }

          if ( typeof currentVariant.opt_3 !== 'undefined' && currentVariant.opt_3 ) {
            console.log ( 'this is available',  );
            $( `.option-selector[op-position="3"] .newCustomSelect__btn > span` ).html( `${ currentVariant.opt_3.replace( '^', '"' ) }` );
            $( `.option-selector[op-position="3"] .newCustomSelect__list .newCustomSelect__item` ).removeAttr( `selected` );
            setTimeout(() => {
              console.log ( 'now changing ', currentVariant.opt_3 );
              $( `.option-selector[op-position="3"] .newCustomSelect__list .newCustomSelect__item[data-value="${ currentVariant.opt_3 }"]` )
              .attr( `selected`, true );
            }, 60);
          }

          select = document.querySelector('form.form.product-purchase-form [name="id"]');
          select.value = currentVariant.id;
          select.dispatchEvent(new Event('change'));

          setTimeout(() => {
            $( `.option-selector[op-position="2"] .opt-label[data-swatch="${ currentVariant.opt_2.toLowerCase() }"]` ).click();
          }, 1000);
        }, 500);
      }
    }
  } catch ( err ) {
    console.log( `ERROR applyRequiredVariant()`, err.message );
  }
}


function setUnavailable() {
  try {
    console.log ( 'setUnavailable function',  );
    $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option` ).each(function() {
      let is_op_1 = $( this ).attr( `op-1` );
      let is_op_2 = $( this ).attr( `op-2` );
      let is_op_3 = $( this ).attr( `op-3` );

      if ( typeof is_op_1 !== 'undefined' && is_op_1.includes( `&quot;` ) ) {
        is_op_1 = is_op_1.replace( `&quot;`, `^` );
      }
      if ( typeof is_op_2 !== 'undefined' && is_op_2.includes( `&quot;` ) ) {
        is_op_2 = is_op_2.replace( `&quot;`, `^` );
      }
      if ( typeof is_op_3 !== 'undefined' && is_op_3.includes( `&quot;` ) ) {
        is_op_3 = is_op_3.replace( `&quot;`, `^` );
      }

      if ( typeof is_op_1 !== 'undefined' && is_op_1 ) {
        const itemCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"]` ).length;
        const outOfStockCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"][data-stock="out"]` ).length;
        if ( itemCount == outOfStockCount ) {
          console.log ( 'outOfStockCount 1', outOfStockCount );
          $( `ul.newCustomSelect__list li.newCustomSelect__item[data-value="${ is_op_1 }"]` ).addClass( `is-unavailable` );
        }
      }

      if ( typeof is_op_1 !== 'undefined' && is_op_1 && typeof is_op_2 !== 'undefined' && is_op_2 ) {
        const itemCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"][op-2="${ is_op_2 }"]` ).length;
        const outOfStockCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"][op-2="${ is_op_2 }"][data-stock="out"]` ).length;
        if ( itemCount == outOfStockCount ) {
          console.log ( 'outOfStockCount 2', outOfStockCount );
          $( `.option-selector[op-position="2"] ul.newCustomSelect__list li.newCustomSelect__item[data-value="${ is_op_2 }"]` ).addClass( `is-unavailable` );
        }
      }
    })
  } catch ( err ) {
    console.log( `ERROR setUnavailable()`, err.message );
  }
}

function selectedItemSetUnavailable() {
  try {
    let is_op_1 = $( `.option-selector[op-position="1"] .newCustomSelect__wrapper .newCustomSelect__item[selected]` ).attr( `data-value` );
    let op_1__updated = $( `.option-selector[op-position="1"] .newCustomSelect__wrapper .newCustomSelect__item[selected]` ).attr( `data-value` );
    let is_op_2 = $( `.option-selector[op-position="2"] .newCustomSelect__wrapper .newCustomSelect__item[selected]` ).attr( `data-value` );
    let op_2__updated = $( `.option-selector[op-position="2"] .newCustomSelect__wrapper .newCustomSelect__item[selected]` ).attr( `data-value` );
    let is_op_3 = $( `.option-selector[op-position="3"] .newCustomSelect__wrapper .newCustomSelect__item[selected]` ).attr( `data-value` );
    let op_3__updated = $( `.option-selector[op-position="3"] .newCustomSelect__wrapper .newCustomSelect__item[selected]` ).attr( `data-value` );

    if ( typeof is_op_1 !== 'undefined' && is_op_1.includes( `&quot;` ) ) {
      op_1__updated = is_op_1.replace( `&quot;`, `^` );
    }
    if ( typeof is_op_2 !== 'undefined' && is_op_2.includes( `&quot;` ) ) {
      op_2__updated = is_op_2.replace( `&quot;`, `^` );
    }
    if ( typeof is_op_3 !== 'undefined' && is_op_3.includes( `&quot;` ) ) {
      op_3__updated = is_op_3.replace( `&quot;`, `^` );
    }

    if ( typeof is_op_1 !== 'undefined' && is_op_1 && typeof is_op_2 !== 'undefined' && is_op_2 && typeof is_op_3 !== 'undefined' && is_op_3 ) {
      // $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"]` ).each(function() {
      //   let op__2 = $( this ).attr( `op-2` );
      //   if ( typeof op__2 !== 'undefined' && op__2.includes( `&quot;` ) ) {
      //     op__2 = op__2.replace( `&quot;`, `^` );
      //   }
      //   if ( typeof op__2 !== 'undefined' && op__2 ) {
      //     const itemCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"][op-2="${ op__2 }"]` ).length;
      //     const outOfStockCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"][op-2="${ op__2 }"][data-stock="out"]` ).length;
      //     if ( itemCount == outOfStockCount ) {
      //       console.log ( 'outOfStockCount 2', outOfStockCount );
      //       $( `.option-selector[op-position="2"] ul.newCustomSelect__list li.newCustomSelect__item[data-value="${ op__2 }"]` ).addClass( `is-unavailable` );
      //     }
      //   }
      // })
    } else if ( typeof is_op_1 !== 'undefined' && is_op_1 && typeof is_op_2 !== 'undefined' && is_op_2 ) {

      // console.log ( 'op_1__updated', op_1__updated );
      $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ op_1__updated }"]` ).each(function() {
        let op__2 = $( this ).attr( `op-2` );
        let op__2_updated = $( this ).attr( `op-2` );
        if ( typeof op__2 !== 'undefined' && op__2.includes( `^` ) ) {
          op__2_updated = op__2.replace( `^`, `&quot;` );
        }
        // console.log ( 'op__2_updated', op__2_updated );
        if ( typeof op__2 !== 'undefined' && op__2 ) {
          $( `.option-selector[op-position="2"] ul.newCustomSelect__list li.newCustomSelect__item[data-value]` ).addClass( `is-unavailable` );
          const itemCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ op_1__updated }"][op-2="${ op__2 }"]` ).length;
          const outOfStockCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ op_1__updated }"][op-2="${ op__2 }"][data-stock="out"]` ).length;
          if ( itemCount != outOfStockCount ) {
            console.log ( 'op__2_updated', op__2_updated );
            setTimeout(() => {
              $( `.option-selector[op-position="2"] ul.newCustomSelect__list li.newCustomSelect__item[data-value="${ op__2_updated }"]` ).removeClass( `is-unavailable` );
            }, 50);
          }
        }
      })
    } else if ( typeof is_op_1 !== 'undefined' && is_op_1 ) {
      // $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"]` ).each(function() {
      //   let op__2 = $( this ).attr( `op-2` );
      //   if ( typeof op__2 !== 'undefined' && op__2.includes( `&quot;` ) ) {
      //     op__2 = op__2.replace( `&quot;`, `^` );
      //   }
      //   if ( typeof op__2 !== 'undefined' && op__2 ) {
      //     const itemCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"][op-2="${ op__2 }"]` ).length;
      //     const outOfStockCount = $( `.buy-buttons-row form.form.product-purchase-form [name="id"] option[op-1="${ is_op_1 }"][op-2="${ op__2 }"][data-stock="out"]` ).length;
      //     if ( itemCount == outOfStockCount ) {
      //       console.log ( 'outOfStockCount 2', outOfStockCount );
      //       $( `.option-selector[op-position="2"] ul.newCustomSelect__list li.newCustomSelect__item[data-value="${ op__2 }"]` ).addClass( `is-unavailable` );
      //     }
      //   }
      // })
    }

    // console.log ( 'is_op_1, is_op_2, is_op_3', is_op_1, is_op_2, is_op_3 );

  } catch ( err ) {
    console.log( `ERROR selectedItemSetUnavailable()`, err.message );
  }
}

function findObjectByKey(array, key, value, multiple) {
  try {
    let rtn = [];
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        if ( multiple ) {
          rtn.push( array[i] );
        } else {
          return array[i];
        }
      }
    }
    if ( multiple && rtn.length > 0 ) {
      return rtn;
    } else {
      return null;
    }
  }
  catch ( err ) {
    console.log( `ERROR findObjectByKey`, err.message );
  }
}